<footer>
  <div class="container-fluid">
    <div class="row ps-4">
      <div
        class="col-12 col-md-4 d-flex align-items-center justify-content-evenly py-4"
      >
        <img
          src="/assets/images/vive-logo-navy.svg"
          alt="VIVE"
          class="footer-logo"
          height="28"
        />
        <a href="https://www.getvived.com/terms-and-conditions" target="_blank"
          >Terms & Conditions</a
        >
        <a href="https://www.getvived.com/privacy-policy" target="_blank">
          Privacy Policy</a
        >
      </div>
    </div>
  </div>
</footer>
